import { forwardRef, useState } from 'react'
import { RadioGroupContext } from './radio-context'
import { StyledRadioGroup } from '../styled-components'
import PropTypes, { oneOf } from 'prop-types'
import { radioDirectionOptions, radioSizeOptions, radioVariantOptions } from '../constants'

const RadioGroup = forwardRef(
  (
    {
      variant = radioVariantOptions.STANDARD,
      size = radioSizeOptions.MEDIUM,
      name,
      defaultValue,
      checked: checkedProp,
      required,
      disabled,
      onValueChange,
      loading = false,
      direction = radioDirectionOptions.COL,
      ...groupProps
    },
    forwardedRef
  ) => {
    const [valueComponent, setValueComponent] = useState(defaultValue)

    const setValue = (newValue) => {
      if (onValueChange) {
        onValueChange(newValue)
      }
      setValueComponent(newValue)
    }
    const value = checkedProp ?? valueComponent

    return (
      <RadioGroupContext.Provider
        value={{
          value,
          onValueChange: setValue,
          disabled,
          required,
          variant,
          size,
          loading
        }}
      >
        <StyledRadioGroup
          role="radiogroup"
          direction={direction}
          aria-required={required}
          data-disabled={disabled ? '' : undefined}
          {...groupProps}
          ref={forwardedRef}
        />
      </RadioGroupContext.Provider>
    )
  }
)

RadioGroup.propTypes = {
  disabled: PropTypes.bool,
  variant: oneOf(Object.values(radioVariantOptions)),
  size: oneOf(Object.values(radioSizeOptions)),
  direction: oneOf(Object.values(radioDirectionOptions)),
  name: PropTypes.string,
  defaultValue: PropTypes.string,
  checked: PropTypes.string,
  required: PropTypes.bool,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool
}

RadioGroup.displayName = 'RadioGroup'
export default RadioGroup
